import { Dialog as RDialog } from 'radix-ui';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Bottom sheet (phone): same Radix dialog as `Dialog`, anchored to the bottom with safe-area padding. */
export function SheetContent({
  title,
  description,
  children,
  className,
  footer,
}: {
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  className?: string;
  footer?: ReactNode;
}) {
  return (
    <RDialog.Portal>
      <RDialog.Overlay className="fixed inset-0 z-50 bg-[var(--overlay)]" />
      <RDialog.Content
        className={cn(
          'fixed inset-x-0 bottom-0 z-50 flex max-h-[85dvh] flex-col rounded-t-2xl border border-b-0 border-border bg-bg shadow-pop focus:outline-none',
          className,
          'max-w-none',
        )}
      >
        <div aria-hidden className="mx-auto mt-2 h-1 w-9 shrink-0 rounded-full bg-border-strong" />
        <div className="flex items-center justify-between px-4 pt-2 pb-1">
          <RDialog.Title className="text-lg font-semibold">{title}</RDialog.Title>
          <RDialog.Close
            className="inline-flex h-10 w-10 items-center justify-center rounded-full text-muted hover:bg-hover hover:text-fg"
            aria-label="Close"
          >
            ✕
          </RDialog.Close>
        </div>
        {description ? (
          <RDialog.Description className="px-4 text-sm text-muted">{description}</RDialog.Description>
        ) : (
          <RDialog.Description className="sr-only">{title}</RDialog.Description>
        )}
        <div data-scroll className="overflow-y-auto px-4 py-3">
          {children}
        </div>
        <div
          className="flex flex-col-reverse gap-2 border-t border-border px-4 pt-3 empty:hidden"
          style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
        >
          {footer}
        </div>
      </RDialog.Content>
    </RDialog.Portal>
  );
}
